export default "/images/01d1b05479ea8f896c6bb3a2519ad058.avif";